// @flow

const STORAGE_KEY = 'pdb-compare-ids/v1';

export const getPdbIdsFromStorage = (): Array<string> => {
  const storage: ?string = localStorage.getItem(STORAGE_KEY);
  if (storage) {
    const pdbCompareIds: Array<string> = JSON.parse(storage);
    if (Array.isArray(pdbCompareIds)) {
      return pdbCompareIds;
    }
  }
  return [];
};

export const storePdbIdInStorage = (pdbIds: Array<string>) => (
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pdbIds))
);
